 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		235: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"5dea399","1":"5867865","2":"9a0966b","3":"2ffbe3e","4":"a77f42e","5":"2644f37","6":"e04d74d","7":"3c58b10","8":"67297fa","9":"79ec6a4","10":"e712b6c","11":"70269b9","12":"241e1bc","13":"1b06178","14":"85e0068","15":"d0baae2","16":"46699bd","17":"27395b9","18":"17de73f","19":"8cee0b7","20":"89b281b","21":"16af392","22":"b3446de","23":"3f8d80b","24":"63fc568","25":"68ed176","26":"c1681af","27":"353771d","28":"e48fb8b","29":"9e222b0","30":"f4d918a","31":"d65419b","32":"98fa113","33":"e257bff","34":"4c740d1","35":"49a57a3","36":"3edcb79","37":"0a3b846","38":"d39f723","39":"efdb8cb","40":"46f44c6","41":"2b1c257","42":"6bd60d8","43":"46ae392","44":"102196e","45":"f96c1e6","46":"40de3f2","47":"5b1f881","48":"89f4c58","49":"4c28fcd","50":"b172db5","51":"1c9f2d8","52":"2b1a9e7","53":"f3b1555","54":"54fefea","55":"b74dad2","56":"3a7a7f8","57":"5720e93","58":"b88e207","59":"8fff125","60":"9a11722","61":"e1e0a57","62":"159740b","63":"5097ed6","64":"e11a311","65":"9d8e986","66":"7ab72be","67":"e7904b9","68":"aa38f9e","69":"c3b4e9c","70":"4d0fc6d","71":"9c6eb83","72":"e700619","73":"c0a251a","74":"8cf0efe","75":"4824cad","76":"5bd20c1","77":"48abd76","78":"fa42d1a","79":"c71b185","80":"02f5969","81":"fff92fe","82":"521b36f","83":"81ee0a7","84":"c95751c","85":"1464460","86":"573bce1","87":"e12d815","88":"e9e49cc","89":"7f7d285","90":"362409c","91":"7948264","92":"69dc411","93":"aaf51be","94":"d971ae5","95":"c7154dd","96":"293d25d","97":"9c76c76","98":"f867d35","99":"a684fe0","100":"7d71e5f","101":"5593383","102":"180abb5","103":"b3f0326","104":"9567c2d","105":"203ea5f","106":"16606ed","107":"c7360b1","108":"b61b067","109":"8a4b515","110":"3b4bd92","111":"60d9144","112":"dd778c1","113":"36b38d3","114":"38cdcab","115":"5d6c504","118":"2411dbe","119":"459ec94","120":"343b79d","121":"0ac6524","122":"576683b","123":"b4ae74d","124":"dd540a7","125":"db73055","126":"3882d23","127":"9bbcae1","128":"bb26451","129":"ac608d3","130":"1a82f7f","131":"1ceecad","132":"a433a08","133":"a3a8ef5","134":"ea686d1","135":"a1ee85c","136":"d2eae5d","137":"ec2b05b","138":"90e1af3","139":"c945027","140":"64ee371","141":"541814f","142":"7a6f84a","143":"efeb877","144":"f67f394","145":"9ec65a2","146":"eeaed82","147":"65e6a3d","148":"6952a80","149":"8a69fb9","150":"1771b03","151":"4e56091","152":"b9bbfd3","153":"a48a407","154":"36c89a0","155":"fcf3bdc","156":"33892d4","157":"a33e078","158":"f8cad95","159":"15511d6","160":"ac7c8d5","161":"2c4068f","162":"b0ba183","163":"5c4dd88","164":"eea7d60","165":"1016ae1","166":"da0285b","167":"1cfb909","168":"9bf68aa","169":"2480ded","170":"9ecd7b1","171":"6f13d8b","172":"3f694a2","173":"fd6d88d","174":"c9106a5","175":"4b76f0c","176":"557e48e","177":"6d0d5bb","178":"ae89a20","179":"c13c1b2","180":"fe3cd1e","181":"5127ab6","182":"924555d","183":"67ed88b","184":"cf8e69a","185":"aca4533","186":"fbd58c2","187":"bbf676e","188":"d1bf705","189":"c7ca2c0","190":"e5cdbd8","191":"4e293dd","192":"78d6c47","193":"e2599ba","194":"1d39f42","195":"f4fbd40","196":"7435eb6","197":"7a107b9","198":"8ebc177","199":"14fd620","200":"ffeb4ae","201":"fb6f177","202":"79c0c3d","203":"2d358ba","204":"5fa28a3","205":"25415d7","206":"87fab98","207":"d211dcb","208":"9941124","209":"204630d","210":"f4c07eb","211":"78352be","212":"1b8e384","213":"bf95811","214":"7eaa7de","215":"4dd9102","216":"44ffd5a","217":"d90f921","218":"e06b3bd","219":"1473961","220":"ff62b29","221":"ac58715","222":"449756c","223":"6a3977e","224":"ade2432","225":"1b658c0","226":"a80fe69","227":"281d703","228":"794da27","229":"ebf87a9","230":"e06cc06","231":"25906fe","232":"2e7c7fd","233":"cc9a0c2","234":"67b712a","237":"1977713","238":"e0aefba","239":"5bf8393","240":"d50c426","241":"85aa923","242":"92f5081","243":"20da646","244":"757b086","245":"7692ae5","246":"c2185eb","247":"ea7cf5e","248":"832b662","249":"f209d63","250":"b0fdf2f","251":"d2d4512","252":"5dc2e2d","253":"4f1e7c1","254":"aa3a113","255":"734c993","256":"10d2e61","257":"a51ce82","258":"757c46a","259":"3974a53","260":"d9d1391","261":"4b36c90","262":"a9263dc","263":"432ce41","264":"5b7fb66","265":"04cd1a0","266":"e438bbb","267":"b9423cd","268":"fa10eb5","269":"8f60b3a","270":"c1ec3eb","271":"57f4c68","272":"b3e9ef4","273":"05f3299","274":"34480e4","275":"ee8851d","276":"1f7d217","277":"5827f86","278":"3d69013","279":"bb158f2","280":"68e688b","281":"04e5e85","282":"dce6dc1","283":"b051652","284":"e8caea9","285":"d76fed8","286":"aaa6342","287":"d23b67f","288":"99a5b74","289":"8670c58","290":"6d6ab6d","291":"d847e58","292":"7b26fef","293":"4dedb84","294":"719eaab","295":"514bef8","296":"91098dd","297":"c40f3f2","298":"1b419a5","299":"23e2e12","300":"b4fdcae","301":"a72a9a3","302":"14843cf","303":"8a3aba9","304":"d51ce9b","305":"b07360e","306":"c804825","307":"20bcc37","308":"26a4321","309":"272a98e","310":"c47aac6","311":"e69dcc3","312":"4d50831","313":"e7e251e","314":"eb5bbc0","315":"1bc6071","316":"7421278","317":"0c593ef","318":"86bbbe9","319":"6829d62","320":"3c62545","321":"dd8f44f","322":"a41ad97","323":"7193c2a","324":"dbc3a99","325":"e71233f","326":"40902df","327":"45cbe95","328":"0ceb0e4","329":"73c43cc","330":"01d2d3d","331":"2e8d62a","332":"c2418db","333":"1f14481","334":"6753b79","335":"3352169","336":"7094c92","337":"fcc759e","338":"c6282e7","339":"9968a9c","340":"4bf7504","341":"493240e","342":"e7ebe8f","343":"efa68fe","344":"b5ffe59","345":"6b16649","346":"5fd7a17","347":"b01dff1","348":"d131708","349":"0e41fe9","350":"562721e","351":"6ee8d92","352":"e6f43a8","353":"b13f752","354":"bbc36cf","355":"63c27bd","356":"27ebd20","357":"8fc344a","358":"a82d73a","359":"0e38a97","360":"d549b24","361":"6f71d19","362":"8f5a6f6","363":"4641ab6","364":"83982dd","365":"b887e4e","366":"a623853","367":"4195ce4","368":"d5ddf08"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
